export default class DiaShow {
    protected interval = 1500;
    protected reloadInterval = 1000 * 60 * 10; // 10 Minuten

    constructor() {
        document.querySelectorAll('.diashow').forEach((el: HTMLElement) => this.initLoad(el));
        // document.querySelectorAll('.diashow').forEach((el: HTMLElement) =>  this.initShow(el));
    }

    async initLoad(container) {
        window.setTimeout(() => this.initShow(container), 1000);
    }
    async initShow(container) {
        (<NodeListOf<HTMLImageElement>>container.querySelectorAll('img.img-lazy')).forEach(
            (img: HTMLImageElement) => {
                img.src = img.dataset.lazy;
                img.addEventListener('load', (el) => {
                    img.width = img.width;
                    img.height = img.height;
                });
            }
        );
        const imageForHeight = container.querySelector('.images .item img');
        if (imageForHeight.complete) {
            this.imageLoaded(container, imageForHeight);
        } else {
            imageForHeight.addEventListener('load', () => this.imageLoaded(container, imageForHeight));
        }
        window.setTimeout(() => this.reloadDia(container), this.reloadInterval);
    }

    imageLoaded(container, imageForHeight) {
        const $container = $(container);
        const _this = this;
        const containerHeight =
            $(imageForHeight).outerHeight() +
            $container.find('.slider-options-outer').outerHeight();
        container.style.height = containerHeight + 'px';
        let $items = $container.find('.item');
        window.addEventListener('resize', (event) => {
            const containerHeight =
                $(imageForHeight).outerHeight() +
                $container.find('.slider-options-outer').outerHeight();
            container.style.height = containerHeight + 'px';
        });
        $items.each(function (i) {
            (<HTMLImageElement>$items[i]).src = $(this).find('img')[0].src;
        });
        var _container = {
            handle: null,
            diaSlider: null,
            maxItems: null,
            el: $container,
            index: 0,
            items: $items,
            count: $items.length,
            btnPlayPause: <HTMLElement>container.querySelector('.btn-play'),
            btnBack: <HTMLElement>container.querySelector('.btn-back'),
            btnForward: <HTMLElement>container.querySelector('.btn-forward')
        };
        _container.maxItems = $container.find('.item').length - 1;
        _container.diaSlider = $container.find('.slider-horizontal').slider({
            orientation: 'horizontal',
            range: 'min',
            min: 0,
            max: _container.maxItems,
            value: 0,
            slide: function (event, ui) {
                _this.pause(_container);
                _container.el.find('.item').eq(_container.index).animate({ opacity: 0 }, 400);
                _container.index = ui.value;
                _container.el.find('.item').eq(_container.index).animate({ opacity: 1 }, 100);
            }
        });

        _container.index = 0;
        container.stopped = false;
        _container.handle = window.setTimeout(() => this.start(_container), this.interval);
        _container.btnPlayPause.addEventListener('click', () => this.btnPlayPauseClick(_container));
        _container.btnBack.style.display = 'none';
        _container.btnForward.style.display = 'none';
        _container.btnForward.addEventListener('click', () => this.btnStep(_container, 1));
        _container.btnBack.addEventListener('click', () => this.btnStep(_container, -1));
        $items.each(function (n, item) {
            new Image().src = $(item).find('img').attr('src');
            if (n > 0) {
                $(item).css({ opacity: 0 });
            }
        });
    }

    reloadDia(container) {
        $(container.items).each(function (i) {
            $(this).find('img')[0].src = this.src + '?' + new Date().getTime();
        });
    }

    btnStep(container, step) {
        container.el.find('.item').eq(container.index).animate({ opacity: 0 }, 400);
        if (step < 0) {
            if (container.index - 1 < 0) {
                container.index = container.count - 1;
            } else {
                container.index--;
            }
        } else {
            if (container.index + 1 >= container.count) {
                container.index = 0;
            } else {
                container.index++;
            }
        }
        container.diaSlider.slider('value', container.index);
        container.el.find('.item').eq(container.index).animate({ opacity: 1 }, 100);
    }

    btnPlayPauseClick(container) {
        const btnLabel = container.btnPlayPause.querySelector('span');
        if (btnLabel.textContent === 'Pause') {
            btnLabel.textContent = 'Play';
            container.btnBack.style.display = '';
            container.btnForward.style.display = '';
            container.stopped = true;
        } else {
            container.btnBack.style.display = 'none';
            container.btnForward.style.display = 'none';
            btnLabel.textContent = 'Pause';
            container.stopped = false;
        }
        this.start(container);
    }

    start(container) {
        if (container.stopped) {
            return;
        }
        container.el.find('.item').eq(container.index).animate({ opacity: 0 }, 400);
        container.index++;
        if (container.index >= container.count) {
            container.index = 0;
        }
        container.el.find('.item').eq(container.index).animate({ opacity: 1 }, 100);
        container.diaSlider.slider('value', container.index);
        container.handle = window.setTimeout(() => this.start(container), this.interval);
    }

    pause(container) {
        const _this = this;
        container.stopped = true;
        container.btnBack.style.display = '';
        container.btnForward.style.display = '';
    }
}
